/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DomainUserDto = {
    email: string;
    id: string;
    name: string;
    role: DomainUserDto.role;
};

export namespace DomainUserDto {

    export enum role {
        EDITOR = 'Editor',
        MONITOR_RESPONDER = 'Monitor responder',
        CATALOG_EDITOR = 'Catalog editor',
        VIEWER = 'Viewer',
    }


}
